import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {ReactComponent as Triangle} from '../../assets/images/triangle-outline.svg';
const FooterItem = (props) => {
    const [itemActive, setItemActive] = useState(false);
    const handleItemActive = () => {
        setItemActive(!itemActive);
    }
    return(
        <div className="footer-item px-16 py-16">
            <h2 className="font-bold text-sm uppercase item-header  relative flex items-center justify-between cursor-pointer" onClick={handleItemActive}>
                {props.header}
                <span className={`transition-all duration-500 ease-in-out transform lg:hidden ${itemActive?'rotate-180':'rotate-0'}`}>
                    <Triangle/>
                </span>
            </h2>
            <div className={`${itemActive?'active':''} footer-item-content`}>
                <ul className="list py-16 pb-0">
                    {
                        props.list.map((item,i)=>{
                            return <li className={`${props.list.length === i+1?'mb-0':'mb-10'}`} key={i}><Link to={item.target}>{item.title}</Link></li>
                        })
                    }
                    
                </ul>
            </div>
        </div>
    );
}
export default FooterItem;